import { useState, useEffect } from "react";
import {
  collection, getDocs, doc, updateDoc, deleteDoc,
  setDoc, serverTimestamp, query, orderBy,
} from "firebase/firestore";
import { db } from "../../firebase/config";

const G = {
  bg:"#FAF9F7",s1:"#FFFFFF",s2:"#F4F2EF",border:"#E2DFD9",border2:"#D4D0CA",
  black:"#1C1917",off:"#3D3830",muted:"#8C8078",dim:"#C8C0B8",
  orange:"#D2611A",green:"#16A34A",red:"#DC2626",amber:"#D97706",blue:"#2563EB",
  sans:"'Outfit','Helvetica Neue',Arial,sans-serif",
  mono:"'IBM Plex Mono',monospace",
};

const ROLES = ["comprador","vendedor","admin"];

const ROL_COLOR = { admin:G.orange, vendedor:G.blue, comprador:G.green };
const ESTADO_COLOR = { activo:G.green, pendiente:G.amber, inactivo:G.red };

function Badge({ label, color }) {
  return (
    <span style={{ fontFamily:G.mono, fontSize:8, letterSpacing:1.5, textTransform:"uppercase", color, border:`1px solid ${color}`, padding:"2px 7px", borderRadius:2 }}>
      {label}
    </span>
  );
}

// ── Modal crear usuario ────────────────────────────────────────────────────────
function ModalCrearUsuario({ onCreado, onClose }) {
  const [form, setForm] = useState({ nombre:"", email:"", empresa:"", rol:"comprador", notas:"" });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState("");

  const crear = async () => {
    if (!form.nombre || !form.email) { setError("Nombre y email son obligatorios."); return; }
    setSaving(true); setError("");
    try {
      // Crear usuario en Firestore (sin Firebase Auth — el usuario debe registrarse)
      // Al registrarse, su documento en /usuarios se actualiza con el uid real
      const ref = doc(collection(db, "usuarios_invitados"));
      await setDoc(ref, {
        nombre:   form.nombre,
        email:    form.email.toLowerCase().trim(),
        empresa:  form.empresa,
        rol:      form.rol,
        estado:   "pendiente",
        notas:    form.notas,
        creadoPor:"admin",
        creadoEn: serverTimestamp(),
        updatedAt:serverTimestamp(),
      });
      onCreado();
    } catch(e) {
      setError("Error al crear el usuario: " + e.message);
    }
    setSaving(false);
  };

  const inp = { width:"100%", background:"transparent", border:"none", borderBottom:`1.5px solid ${G.border2}`, color:G.black, fontFamily:G.sans, fontSize:13, padding:"8px 0", outline:"none" };
  const lbl = { fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", color:G.muted, marginBottom:5, fontWeight:600, display:"block" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(28,25,23,.5)", zIndex:300, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ background:G.s1, border:`1.5px solid ${G.border}`, padding:"32px 36px", width:440, maxWidth:"95vw" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
          <div style={{ fontFamily:G.sans, fontSize:18, color:G.black, fontWeight:700 }}>Crear usuario</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, color:G.muted, cursor:"pointer" }}>×</button>
        </div>

        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Nombre completo *</label>
          <input value={form.nombre} onChange={e=>setForm(p=>({...p,nombre:e.target.value}))} placeholder="Arq. Juan García" style={inp}
            onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Email *</label>
          <input type="email" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))} placeholder="juan@estudio.com" style={inp}
            onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Empresa / Estudio</label>
          <input value={form.empresa} onChange={e=>setForm(p=>({...p,empresa:e.target.value}))} placeholder="Estudio García Arquitectura" style={inp}
            onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Rol</label>
          <select value={form.rol} onChange={e=>setForm(p=>({...p,rol:e.target.value}))}
            style={{ ...inp, background:G.s2, border:`1px solid ${G.border}`, padding:"8px 10px" }}>
            {ROLES.map(r => <option key={r} value={r}>{r.charAt(0).toUpperCase()+r.slice(1)}</option>)}
          </select>
        </div>
        <div style={{ marginBottom:24 }}>
          <label style={lbl}>Notas internas</label>
          <input value={form.notas} onChange={e=>setForm(p=>({...p,notas:e.target.value}))} placeholder="Obra Palermo, 20 unidades..." style={inp}
            onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
        </div>

        {error && <div style={{ fontFamily:G.sans, fontSize:11, color:G.red, marginBottom:16, padding:"8px 10px", background:"#FEF2F2" }}>{error}</div>}

        <div style={{ background:G.s2, padding:"12px 14px", marginBottom:20, border:`1px solid ${G.border}` }}>
          <div style={{ fontFamily:G.sans, fontSize:11, color:G.muted, lineHeight:1.6 }}>
            El usuario recibirá un email de invitación para registrarse. Quedará en estado <strong>Pendiente</strong> hasta que vos lo apruebes desde acá.
          </div>
        </div>

        <div style={{ display:"flex", gap:10 }}>
          <button onClick={crear} disabled={saving} style={{ flex:1, padding:"10px 0", background:G.orange, color:"#fff", fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:"none", cursor:"pointer", fontWeight:700, opacity:saving?.6:1 }}>
            {saving ? "Creando..." : "Crear usuario →"}
          </button>
          <button onClick={onClose} style={{ padding:"10px 16px", background:"transparent", color:G.muted, fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:`1.5px solid ${G.border}`, cursor:"pointer" }}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Modal editar usuario ──────────────────────────────────────────────────────
function ModalEditarUsuario({ usuario, onGuardado, onClose }) {
  const [form, setForm] = useState({
    nombre:  usuario.nombre  || "",
    empresa: usuario.empresa || "",
    rol:     usuario.rol     || "comprador",
    estado:  usuario.estado  || "pendiente",
    notas:   usuario.notas   || "",
  });
  const [saving, setSaving] = useState(false);

  const guardar = async () => {
    setSaving(true);
    const col = usuario.fromInvitados ? "usuarios_invitados" : "usuarios";
    await updateDoc(doc(db, col, usuario.id), { ...form, updatedAt: serverTimestamp() });
    setSaving(false);
    onGuardado();
  };

  const inp = { width:"100%", background:"transparent", border:"none", borderBottom:`1.5px solid ${G.border2}`, color:G.black, fontFamily:G.sans, fontSize:13, padding:"8px 0", outline:"none" };
  const lbl = { fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", color:G.muted, marginBottom:5, fontWeight:600, display:"block" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(28,25,23,.5)", zIndex:300, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ background:G.s1, border:`1.5px solid ${G.border}`, padding:"32px 36px", width:440, maxWidth:"95vw" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
          <div style={{ fontFamily:G.sans, fontSize:18, color:G.black, fontWeight:700 }}>Editar usuario</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, color:G.muted, cursor:"pointer" }}>×</button>
        </div>

        <div style={{ fontFamily:G.mono, fontSize:10, color:G.muted, marginBottom:20 }}>{usuario.email}</div>

        {[["Nombre completo","nombre","Arq. Juan García"],["Empresa / Estudio","empresa","Estudio García"]].map(([l,k,ph])=>(
          <div key={k} style={{ marginBottom:16 }}>
            <label style={lbl}>{l}</label>
            <input value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={inp}
              onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
          </div>
        ))}

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
          <div>
            <label style={lbl}>Rol</label>
            <select value={form.rol} onChange={e=>setForm(p=>({...p,rol:e.target.value}))} style={{ ...inp, background:G.s2, border:`1px solid ${G.border}`, padding:"8px 10px" }}>
              {ROLES.map(r => <option key={r} value={r}>{r.charAt(0).toUpperCase()+r.slice(1)}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Estado</label>
            <select value={form.estado} onChange={e=>setForm(p=>({...p,estado:e.target.value}))} style={{ ...inp, background:G.s2, border:`1px solid ${G.border}`, padding:"8px 10px" }}>
              {["activo","pendiente","inactivo"].map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
            </select>
          </div>
        </div>

        <div style={{ marginBottom:24 }}>
          <label style={lbl}>Notas internas</label>
          <input value={form.notas} onChange={e=>setForm(p=>({...p,notas:e.target.value}))} placeholder="Notas..." style={inp}
            onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
        </div>

        <div style={{ display:"flex", gap:10 }}>
          <button onClick={guardar} disabled={saving} style={{ flex:1, padding:"10px 0", background:G.orange, color:"#fff", fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:"none", cursor:"pointer", fontWeight:700 }}>
            {saving ? "Guardando..." : "Guardar cambios"}
          </button>
          <button onClick={onClose} style={{ padding:"10px 16px", background:"transparent", color:G.muted, fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:`1.5px solid ${G.border}`, cursor:"pointer" }}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ──────────────────────────────────────────────────────
export default function AdminUsuarios() {
  const [usuarios,  setUsuarios]  = useState([]);
  const [invitados, setInvitados] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [modal,     setModal]     = useState(null); // "crear" | usuario obj
  const [filtro,    setFiltro]    = useState("todos");
  const [search,    setSearch]    = useState("");

  const cargar = async () => {
    setLoading(true);
    const [uSnap, iSnap] = await Promise.all([
      getDocs(query(collection(db,"usuarios"),  orderBy("creadoEn","desc"))).catch(()=>({docs:[]})),
      getDocs(query(collection(db,"usuarios_invitados"), orderBy("creadoEn","desc"))).catch(()=>({docs:[]})),
    ]);
    setUsuarios( uSnap.docs.map(d=>({ id:d.id, ...d.data() })));
    setInvitados(iSnap.docs.map(d=>({ id:d.id, ...d.data(), fromInvitados:true })));
    setLoading(false);
  };
  useEffect(()=>{ cargar(); },[]);

  const aprobar = async (u) => {
    const col = u.fromInvitados ? "usuarios_invitados" : "usuarios";
    await updateDoc(doc(db, col, u.id), { estado:"activo", updatedAt:serverTimestamp() });
    cargar();
  };

  const eliminar = async (u) => {
    if (!window.confirm(`¿Eliminar usuario ${u.nombre || u.email}?`)) return;
    const col = u.fromInvitados ? "usuarios_invitados" : "usuarios";
    await deleteDoc(doc(db, col, u.id));
    cargar();
  };

  // Combinar y filtrar
  const todos = [...usuarios, ...invitados];
  const filtered = todos.filter(u => {
    const ms = !search || u.nombre?.toLowerCase().includes(search.toLowerCase()) || u.email?.toLowerCase().includes(search.toLowerCase());
    const mf = filtro==="todos" || u.rol===filtro || (filtro==="pendiente" && u.estado==="pendiente");
    return ms && mf;
  });

  const counts = {
    todos:     todos.length,
    pendiente: todos.filter(u=>u.estado==="pendiente").length,
    comprador: todos.filter(u=>u.rol==="comprador").length,
    vendedor:  todos.filter(u=>u.rol==="vendedor").length,
    admin:     todos.filter(u=>u.rol==="admin").length,
  };

  return (
    <div style={{ background:G.bg }}>
      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
        <div>
          <div style={{ fontFamily:G.sans, fontSize:22, color:G.black, fontWeight:700, marginBottom:3 }}>Usuarios</div>
          <div style={{ fontFamily:G.mono, fontSize:10, color:G.muted }}>{todos.length} usuarios totales · {counts.pendiente} pendientes de aprobación</div>
        </div>
        <button onClick={()=>setModal("crear")} style={{ padding:"9px 22px", background:G.orange, color:"#fff", fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:"none", cursor:"pointer", fontWeight:700 }}>
          + Crear usuario
        </button>
      </div>

      {/* KPIs */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:8, marginBottom:20 }}>
        {[["todos","Total",counts.todos,G.muted],["pendiente","Pendientes",counts.pendiente,G.amber],["comprador","Compradores",counts.comprador,G.green],["vendedor","Vendedores",counts.vendedor,G.blue],["admin","Admins",counts.admin,G.orange]].map(([k,l,n,c])=>(
          <div key={k} onClick={()=>setFiltro(k)} style={{ background:filtro===k?G.orange:G.s1, border:`1.5px solid ${filtro===k?G.orange:G.border}`, padding:"14px 16px", cursor:"pointer", transition:"all .15s" }}>
            <div style={{ fontFamily:G.sans, fontSize:8, letterSpacing:2, textTransform:"uppercase", color:filtro===k?"rgba(255,255,255,.7)":G.muted, marginBottom:4, fontWeight:600 }}>{l}</div>
            <div style={{ fontFamily:G.sans, fontSize:22, fontWeight:700, color:filtro===k?"#fff":c }}>{n}</div>
          </div>
        ))}
      </div>

      {/* Alerta pendientes */}
      {counts.pendiente > 0 && (
        <div style={{ background:"#FFFBEB", border:`1.5px solid ${G.amber}`, padding:"12px 16px", marginBottom:16, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div style={{ fontFamily:G.sans, fontSize:12, color:G.off }}>
            <strong>{counts.pendiente} usuario{counts.pendiente>1?"s":""}</strong> esperando aprobación.
          </div>
          <button onClick={()=>setFiltro("pendiente")} style={{ fontFamily:G.sans, fontSize:9, letterSpacing:1.5, textTransform:"uppercase", background:G.amber, color:"#fff", border:"none", padding:"5px 12px", cursor:"pointer", fontWeight:700 }}>
            Ver pendientes
          </button>
        </div>
      )}

      {/* Búsqueda */}
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar por nombre o email..."
        style={{ width:280, background:G.s1, border:`1.5px solid ${G.border}`, color:G.black, fontFamily:G.sans, fontSize:12, padding:"7px 12px", outline:"none", marginBottom:14 }}/>

      {/* Tabla */}
      {loading ? (
        <div style={{ padding:40, textAlign:"center", fontFamily:G.sans, fontSize:12, color:G.muted }}>Cargando...</div>
      ) : (
        <div style={{ background:G.border }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 90px 90px 90px 120px", background:G.s2, padding:"8px 14px", gap:8 }}>
            {["Nombre","Email","Rol","Estado","Empresa","Acciones"].map(h=>(
              <div key={h} style={{ fontFamily:G.sans, fontSize:8, letterSpacing:2, color:G.muted, textTransform:"uppercase", fontWeight:600 }}>{h}</div>
            ))}
          </div>
          {filtered.length===0 && (
            <div style={{ background:G.s1, padding:32, textAlign:"center", fontFamily:G.sans, fontSize:12, color:G.muted }}>
              Sin usuarios en esta categoría.
            </div>
          )}
          {filtered.map(u=>(
            <div key={u.id} style={{ display:"grid", gridTemplateColumns:"1fr 1fr 90px 90px 90px 120px", background:G.s1, padding:"12px 14px", gap:8, borderBottom:`1px solid ${G.border}`, alignItems:"center" }}>
              <div>
                <div style={{ fontFamily:G.sans, fontSize:12, color:G.black, fontWeight:600 }}>{u.nombre || "—"}</div>
                {u.notas && <div style={{ fontFamily:G.sans, fontSize:10, color:G.muted, marginTop:1 }}>{u.notas}</div>}
              </div>
              <div style={{ fontFamily:G.mono, fontSize:10, color:G.muted, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{u.email}</div>
              <Badge label={u.rol||"—"} color={ROL_COLOR[u.rol]||G.muted}/>
              <Badge label={u.estado||"pendiente"} color={ESTADO_COLOR[u.estado||"pendiente"]}/>
              <div style={{ fontFamily:G.sans, fontSize:10, color:G.muted }}>{u.empresa||"—"}</div>
              <div style={{ display:"flex", gap:4 }}>
                {u.estado==="pendiente" && (
                  <button onClick={()=>aprobar(u)} title="Aprobar" style={{ fontFamily:G.sans, fontSize:8, letterSpacing:1, textTransform:"uppercase", background:G.green, color:"#fff", border:"none", padding:"3px 8px", cursor:"pointer", fontWeight:700 }}>✓ Aprobar</button>
                )}
                <button onClick={()=>setModal(u)} title="Editar" style={{ fontFamily:G.mono, fontSize:13, color:G.blue, background:"none", border:"none", cursor:"pointer", padding:"0 4px" }}>✎</button>
                <button onClick={()=>eliminar(u)} title="Eliminar" style={{ fontFamily:G.mono, fontSize:13, color:G.red, background:"none", border:"none", cursor:"pointer", padding:"0 4px" }}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modales */}
      {modal==="crear" && <ModalCrearUsuario onCreado={()=>{ setModal(null); cargar(); }} onClose={()=>setModal(null)}/>}
      {modal && modal!=="crear" && <ModalEditarUsuario usuario={modal} onGuardado={()=>{ setModal(null); cargar(); }} onClose={()=>setModal(null)}/>}
    </div>
  );
}
